// extracted by mini-css-extract-plugin
export default {"overlay-modal":"modal_overlay-modal__umN4W","modal":"modal_modal__pp2YE","close":"modal_close__s7NYT","primary":"modal_primary__Kyxts"};